import axios from '@/libs/http'

/**
 * 获取微信网页授权url
 */
export const getWeixinOAuth2Url = (uri) => {
  return axios.request({
    url: '/s/weixin/getOAuth2Url',
    params: {
      uri
    },
    method: 'get'
  })
}

/**
 * 获取jssdk配置参数
 */
export const getWeixinJsSdkSign = (url) => {
  return axios.request({
    url: '/s/weixin/getJsSdkSign',
    params: {
      url
    },
    method: 'get'
  })
}

